import { useEffect } from "react";

const SITE = "https://www.vidalv.live";
const DEFAULT_OG_IMAGE = `${SITE}/og-cover.jpg`;

function setMeta(selector, content) {
  if (!content) return;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const m = selector.match(/\[([^=]+)="([^"]+)"\]/);
    if (m) el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

/**
 * Sätter title, meta-description, canonical, OG och valfri JSON-LD per sida.
 * Hjälper Googlebot (som kör JS) men lämnar facebook/whatsapp som öppen punkt
 * (kräver SSR för att vara fullständig).
 *
 * @param {Object}  opts
 * @param {string}  opts.title       — Document title
 * @param {string}  opts.description — meta description / og:description
 * @param {string} [opts.path]       — relativ sökväg, t.ex. "/evenemang/123"
 * @param {string} [opts.image]      — absolut OG-bild
 * @param {Object} [opts.jsonLd]     — valfri schema.org-struktur (rensas på unmount)
 * @param {string} [opts.jsonLdId]   — DOM-id för JSON-LD-noden (default "ld-page")
 */
export function usePageMeta({ title, description, path, image, jsonLd, jsonLdId = "ld-page", skip = false }) {
  useEffect(() => {
    if (skip) return;
    if (title) document.title = title;
    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:description"]', description);
      setMeta('meta[name="twitter:description"]', description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', title);
      setMeta('meta[name="twitter:title"]', title);
    }
    if (path) {
      const url = path.startsWith("http") ? path : `${SITE}${path}`;
      setLink("canonical", url);
      setMeta('meta[property="og:url"]', url);
    }
    const img = image || DEFAULT_OG_IMAGE;
    setMeta('meta[property="og:image"]', img);
    setMeta('meta[name="twitter:image"]', img);

    if (jsonLd) setJsonLd(jsonLdId, jsonLd);
    return () => {
      if (jsonLd) {
        const el = document.getElementById(jsonLdId);
        if (el) el.remove();
      }
    };
  }, [title, description, path, image, jsonLd, jsonLdId, skip]);
}

export { SITE };
